import {PartyType} from '@sollapay/enums';
import {useTranslation} from 'react-i18next';

import {PartyTypeToggle} from '@/components/roster';

import type {ButtonGroupItemDef} from '@sollapay/ui/components';
import type {FC} from 'react';

export interface BuyerTypeToggleProps {
  value: PartyType;
  onChange: (value: PartyType) => void;
}

export const BuyerTypeToggle: FC<BuyerTypeToggleProps> = ({value, onChange}) => {
  const {t} = useTranslation('trustAccounts');
  const prefix = 'view.buyers.addBuyerModal.buyerType';

  const items: ButtonGroupItemDef[] = [
    {value: PartyType.PERSON, label: t(`${prefix}.individual`), icon: 'user'},
    {value: PartyType.ORGANIZATION, label: t(`${prefix}.corporate`), icon: 'building'}
  ];

  return (
    <PartyTypeToggle
      label={t(`${prefix}.label`)}
      required
      value={value}
      onChange={val => onChange(val as PartyType)}
      items={items}
    />
  );
};
